<template>
  <div class="user-dialog">
    <gs-modal
      v-model="visible"
      :title="'用户-'+form.username"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      top="10%"
      class="user-dialog-modal"
      width="30%"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="用户可见"
          name="userVista"
          icon="star"
        >
          <div class="page-form">
            <gs-form
              ref="form"
              :model="form"
              class="form"
              label-width="100px"
              label-position="left"
            >
              <div class="general">
                <div class="title">概述</div>
                <gs-form-item
                  label="用户名"
                  prop="username"
                  class="form-item-username"
                >
                  <gs-input
                    ref="nameInput"
                    v-model="form.username"
                    type="text"
                  />
                </gs-form-item>
                <gs-form-item
                  label="描述"
                  prop="description"
                  class="form-item-description"
                >
                  <gs-input
                    v-model="form.description"
                    type="text"
                  />
                </gs-form-item>

                <gs-form-item
                  label="密码"
                  prop="password"
                  class="form-item-password"
                >
                  <gs-input
                    v-model="password"
                    type="password"
                    placeholder="请输入用户密码"
                  />
                </gs-form-item>

                <gs-form-item
                  label="权限级别"
                  prop="authorityLevel"
                >
                  <gs-select v-model="form.authorityLevel">
                    <gs-option
                      label="普通用户"
                      value="USER"
                    />
                    <gs-option
                      label="审查员"
                      value="FIELD_NAMAGER"
                    />
                    <gs-option
                      label="操作员"
                      value="OPERATION_MANAGER"
                    />
                    <gs-option
                      label="超级管理员"
                      value="SYSTEM_MANAGER"
                    />
                  </gs-select>
                </gs-form-item>

                <!-- <gs-form-item
                  label="用户配置"
                  prop="userProfile"
                  class="form-item-userProfile"
                >
                  <gs-input
                    v-model="form.userProfile"
                    type="text"
                    placeholder="请输入用户配置"
                  />
                </gs-form-item> -->
              </div>
              <div class="automaticLogout">
                <div class="title">自动注销</div>
                <gs-form-item
                  label="注销时间（分）"
                  prop="logoutTime"
                  class="form-item-logoutTime"
                >
                  <gs-input
                    v-model="form.logoutTime"
                    type="number"
                    placeholder="请输入注销时间"
                  />
                </gs-form-item>

                <!-- <gs-form-item
                  label="待机时间（分）"
                  prop="standbyTime"
                  class="form-item-standbyTime"
                >
                  <gs-input
                    v-model="form.standbyTime"
                    type="number"
                    placeholder="请输入待机时间"
                  />
                </gs-form-item> -->
              </div>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/authorityService.js'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      activeName: 'userVista',
      form: {
        userId: '',
        username: '',
        description: '',
        authorityLevel: '',
        userProfile: '',
        logoutTime: '',
        standbyTime: ''
      },
      password: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'userShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        service.getUserDetail(this.objectData.userId).then(res => {
          this.form = res
        })
        this.password = '******'
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'USER_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    handleConfirm() {
      let params = {}
      if (this.password === '******') {
        params = {
          'userId': this.form.userId,
          'username': this.form.username,
          'description': this.form.description,
          'authorityLevel': this.form.authorityLevel,
          'logoutTime': this.form.logoutTime,
          'parentId':localStorage.getItem('userId')
        }
      } else {
        params = {
          'userId': this.form.userId,
          'username': this.form.username,
          'password': this.password,
          'description': this.form.description,
          'authorityLevel': this.form.authorityLevel,
          'logoutTime': this.form.logoutTime,
          'parentId':localStorage.getItem('userId')
        }
      }
      service.updateUser(params).then(res => {
        this.$Message.success('修改用户成功!')
        this.close()
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    beforeConfirm(e, done) {
      if (this.password === '' || this.password.length < 4) {
        this.$Message.warning('密码不能小于4位')
        return
      }
      done()
    },
    beforeClose(e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.user-dialog {
  &-modal {
    overflow: hidden;
    .page-form {
      .title {
        color: #0073e8;
        margin-bottom: 12px;
      }
      .gs-form-item {
        margin-bottom: 12px;
      }
      .button {
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authority/user.vue